
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["sumMapper","resolveDiceTotals","rollDice","calculateProbability"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "b218dc83d83e706840fe.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			